module.exports = __webpack_public_path__ + "img/uk_Ecran 4.aa10bbb5.png";